import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { useDrag } from 'react-dnd';
import { ChannelDatePopup } from './channel-date-popup';
import { savePlan } from '../store/slice';

const ItemType = 'DRAGGABLE_ITEM';

const wrapperStyles = {
  border: '1px solid #171923',
  fontSize: '14px',
  fontWeight: 'bold',
  background: '#1a202',
  borderRadius: '6px',
  marginRight: '10px',
};
const contentStyles = {
  backgroundColor: '#1a202c',
  color: '#fff',
  padding: '15px 25px',
  display: 'flex',
  justifyContent: 'center',
  cursor: 'move',
  whiteSpace: 'nowrap',
};

export const BoxWithHandle = ({ data }) => {
  const dispatch = useDispatch();
  const { id, duration, title, description } = data;
  const [showPopup, setShowPopup] = useState(false);

  const [{ opacity }, drag, preview] = useDrag(() => ({
    type: ItemType,
    collect: monitor => ({
      opacity: monitor.isDragging() ? 0.8 : 1,
      isDragging: monitor.isDragging(),
      handlerId: monitor.getHandlerId(),
    }),
    item: { id },
  }));

  const handleClick = () => {
    setShowPopup(true);
  };

  const handleSave = scheduleData => {
    const payload = {
      title: id,
      channelUuid: scheduleData.channel,
      description: description,
      materialBatchNumber: scheduleData.materialBatchNumber,
      since: scheduleData.startDate + 'T00:00:00',
      till: scheduleData.startDate + 'T24:00:00',
    };

    dispatch(savePlan(payload));
    setShowPopup(false);
  };

  return (
    <>
      <div ref={preview} style={{ ...wrapperStyles, opacity }} onClick={handleClick}>
        <div
          ref={drag}
          id={id}
          style={contentStyles}
          onDragStart={e => e.dataTransfer.setData('text/plain', id)}
          data-title={title}
          data-description={description}
          // Example for mode: { type: "day" },
          data-duration={duration} // In minutes
          // Example for mode: { type: "week" }, one day
          // data-duration="1439" // In minutes
          // Example for mode: { type: "month" }, one month
          // data-duration="43170" // In minutes
          // More data-attributes can be added here
        >
          {title} - {description}
        </div>
      </div>
      <ChannelDatePopup show={showPopup} onClose={() => setShowPopup(false)} onSave={handleSave} />
    </>
  );
};
